import {
  Button,
  Card,
  CardActionArea,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Slide
} from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import Context from '../../../context'

const Transition = React.forwardRef((props, ref) => {
  /* eslint react/jsx-props-no-spreading:0 */
  return <Slide direction="up" ref={ref} {...props} />
})

function DeleteDialog() {
  const { openImageDialog, setOpenImageDialog, imageData } = useContext(Context)

  const handleClose = () => {
    setOpenImageDialog(false)
  }

  useEffect(() => {
    console.log(imageData)
  }, [imageData])

  return (
    <Dialog
      open={openImageDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{imageData.local}</DialogTitle>
      <DialogContent>
        <Card>
          <CardActionArea style={{ padding: '15px' }}>
            <Grid container>
              <Grid item xs={12} style={{ maxWidth: '600px', maxHeight: '600px' }}>
                <img
                  src={imageData.url}
                  alt={imageData.local}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '10px' }}>
              <Button variant="contained" onClick={handleClose} color="primary">
                Fechar
              </Button>
            </Grid>
          </CardActionArea>
        </Card>
      </DialogContent>
    </Dialog>
  )
}

export default DeleteDialog
